







import { Component, Mixins } from "vue-property-decorator";
import { default as MediaRotatableContentMixin } from "./mixins/MediaRotatableContentMixin.vue";
import { instanceOfIFixedTextIndicatable, instanceOfIWizardObjectRotatable } from "../../../../../../domain/format";
import { FatalIndicator } from "./common";

@Component({
  components: {
    FatalIndicator,
  }
})
export default class WizardContentMediaRotater extends Mixins(MediaRotatableContentMixin) {
  get text(): string {
    return instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : "回転";
  }

  get angle(): number {
    return instanceOfIWizardObjectRotatable(this.content)
      ? this.content.angle
      : null;
  }

  onRotateImageClicked() {
    this.rotateImage(this.angle);
  }
}
